import { useCallback, useEffect, useState } from 'react'

import { GeoCoordinates } from '@/features/web/move_log/shared-types'
import { useRequestCurrentPosition } from '@/hooks/use-request-current-position'

export function useCurrentPosition({ interval }: { interval?: number } = {}) {
  const requestCurrentPosition = useRequestCurrentPosition()
  const [position, setPosition] = useState<GeoCoordinates | null>(null)
  const refresh = useCallback(() => {
    return requestCurrentPosition().then((position) => {
      if (position) {
        setPosition(position)
      }
      return position
    })
  }, [requestCurrentPosition])

  useEffect(() => {
    refresh()
  }, [refresh])

  useEffect(() => {
    if (!interval) return
    let unmounted = false
    let timerId = 0
    const run = () => {
      if (unmounted) return
      timerId = window.setTimeout(async () => {
        await refresh()
        run()
      }, interval)
    }
    run()
    return () => {
      unmounted = true
      clearTimeout(timerId)
    }
  }, [refresh, interval])

  return [position, refresh] as const
}
